import { UserRole } from '../enums/global.enum';

export class RolesConstants {
  // Dashboard
  public static DASHBOARD_VIEW = [UserRole.Customer, UserRole.Owner, UserRole.Controller, UserRole.Fleet];
  public static DASHBOARD_ORGANIZATION_VIEW = [UserRole.OrganizationOwner];
  public static DASHBOARD_ANY_VIEW = [...RolesConstants.DASHBOARD_VIEW, ...RolesConstants.DASHBOARD_ORGANIZATION_VIEW];
  // Shipment list
  public static CUSTOMER_SHIPMENT_LIST_VIEW = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static SHIPMENT_LIST_VIEW = [UserRole.OrganizationOwner, UserRole.Fleet];
  public static SHIPMENT_LIST_ORGANIZATION_VIEW = [UserRole.OrganizationOwner];
  public static SHIPMENT_DETAILS_VIEW = [
    UserRole.Owner,
    UserRole.Customer,
    UserRole.OrganizationOwner,
    UserRole.Fleet,
    UserRole.Controller
  ];
  public static SHIPMENT_DETAILS_OWNER_CUSTOMER_ORGANIZATION_VIEW = [
    UserRole.Owner,
    UserRole.Customer,
    UserRole.Controller,
    UserRole.OrganizationOwner,
  ];
  public static SHIPMENT_ADD = [UserRole.Owner, UserRole.Customer, UserRole.Controller, UserRole.OrganizationOwner];
  public static SHIPMENT_EDIT = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static SHIPMENT_MARK_AS_CANCELED = [UserRole.Customer, UserRole.Owner, UserRole.Controller];
  public static SHIPMENT_MARK_AS_DELIVERED = [UserRole.Customer, UserRole.Owner, UserRole.Controller];

  public static SHIPMENT_DELETE = [UserRole.Customer, UserRole.Owner, UserRole.Controller];

  // Order
  public static ORDER_ADD = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  // fleets
  public static FLEET_LIST_VIEW = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static FLEET_CREATE = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static FLEET_DETAILS_VIEW = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static FLEET_REQUEST_VIEW = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static FLEET_MADAR_LIST_VIEW = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static FLEET_USER_CREATE = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static FLEET_USER_EDIT = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static FLEET_DRIVER_CREATE = [UserRole.Owner, UserRole.Customer, UserRole.Controller, UserRole.Fleet];
  public static FLEET_DRIVER_EDIT = [UserRole.Owner, UserRole.Customer, UserRole.Controller, UserRole.Fleet];
  public static FLEET_TRUCK_CREATE = [UserRole.Owner, UserRole.Customer, UserRole.Controller, UserRole.Fleet];
  public static FLEET_TRUCK_VIEW = [UserRole.Owner, UserRole.Customer, UserRole.Controller, UserRole.Fleet];
  public static FLEET_TRUCK_EDIT = [UserRole.Owner, UserRole.Customer, UserRole.Controller, UserRole.Fleet];
  public static VIEW_EDIT_TRUCK_DRIVER_OPTION = [UserRole.Fleet];
  public static VIEW_TRUCK_DRIVER_OPTIONS = [UserRole.Fleet];
  public static FLEET_TRAILER_CREATE = [UserRole.Owner, UserRole.Customer, UserRole.Controller, UserRole.Fleet];

  //drivers
  public static DRIVERS_DISTANCE_SHIPMENTS_EXPORT = [UserRole.Fleet];

  public static FLEET_USER_TRUCKS = [UserRole.Fleet];
  public static CUSTOMER_TRIP_PLANNING = [
    UserRole.Customer,
    UserRole.Controller,
    UserRole.Owner,
    UserRole.OrganizationOwner,
  ];
  public static FLEET_USER_DRIVERS = [UserRole.Fleet];
  public static FLEET_USER_RENTED_TRUCKS = [UserRole.Fleet];
  public static FLEET_USER_USERS = [UserRole.Fleet];
  public static FLEET_ACCEPT_SHIPMENTS = [UserRole.Fleet];
  public static FLEET_ADD_BULK_DRIVERS_AND_TRUCKS = [
    UserRole.Fleet,
    UserRole.Customer,
    UserRole.Controller,
    UserRole.Owner,
  ];
  public static EXPORT_DRIVERS_TRUCKS = [UserRole.Customer, UserRole.Controller];
  public static FLEET_INFO_VIEW = [UserRole.Fleet];

  // manage
  public static MANAGE_VIEW = [
    UserRole.Owner,
    UserRole.Customer,
    UserRole.Controller,
    UserRole.Fleet,
    UserRole.OrganizationOwner,
  ];
  public static SHOW_CEMENT_BALANCE = [UserRole.Owner, UserRole.OrganizationOwner];

  // customer
  public static CUSTOMER_INFO_VIEW = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static CUSTOMER_LIST_VIEW = [UserRole.OrganizationOwner];
  public static CUSTOMER_CREATE = [];
  public static CUSTOMER_EDIT = [UserRole.Owner, UserRole.Customer, UserRole.Controller, UserRole.OrganizationOwner];
  public static LOCATION_CUSTOMER_VIEW = [
    UserRole.OrganizationOwner,
    UserRole.Customer,
    UserRole.Controller,
    UserRole.Owner,
  ];
  public static CUSTOMER_ADD_EDIT_USER = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static MY_CUSTOMERS_VIEW = [UserRole.Customer, UserRole.Owner, UserRole.Controller];
  public static MY_WALLET_VIEW = [UserRole.Customer, UserRole.Owner, UserRole.Controller];
  public static MY_CUSTOMER_ADD = [UserRole.Customer, UserRole.Owner, UserRole.Controller];

  public static USER_VIEW = [UserRole.Owner, UserRole.Customer, UserRole.Controller, UserRole.OrganizationOwner];
  public static USER_CREATE = [UserRole.Owner, UserRole.Customer, UserRole.Controller];
  public static USER_EDIT = [UserRole.Owner, UserRole.Customer, UserRole.Controller, UserRole.OrganizationOwner];

  public static RECEIVERS_EDIT = [];

  // customer Locations
  public static LOCATION_STATUS_EDIT = [UserRole.OrganizationOwner];

  public static LOCATION_STATUS_VIEW_ALL = [UserRole.OrganizationOwner];

  // invoice
  public static INVOICE_LIST_VIEW = [UserRole.Customer, UserRole.Controller, UserRole.Owner];
  public static DELIVERY_NOTE_LIST_VIEW = [UserRole.Customer, UserRole.Controller, UserRole.Owner];
  public static VIEW_FLEET_INVOICES_LIST = [UserRole.Fleet];
  public static CREATE_FLEET_IVOICE_VIEW = [UserRole.Fleet];

  // transactions
  public static TRANSACTIONS_LIST_VIEW = [UserRole.Customer, UserRole.Controller, UserRole.Owner];

  //contracts
  public static CONTRACTS_CUSTOMER_VIEW = [UserRole.Customer, UserRole.Controller, UserRole.Owner];
  public static CONTRACTS_FLEET_VIEW = [UserRole.Fleet];
  public static CONTRACTS_CUSTOMER_FLEET_VIEW = [UserRole.Customer, UserRole.Controller, UserRole.Owner, UserRole.Fleet];

  //eta configuration
  public static ETA_VAT_CONFIGURATION_ORGANIZATION_VIEW = [UserRole.OrganizationOwner];

  //reports
  public static REPORT = [UserRole.Fleet, UserRole.Customer, UserRole.Controller, UserRole.Owner];
  public static TRUCKS_REPORT = [UserRole.Fleet];
  public static G2G_REPORT = [UserRole.Fleet, UserRole.Customer, UserRole.Controller, UserRole.Owner];
  public static TRUCKS_OPERATION_EDIT = [
    UserRole.Fleet,
    UserRole.Customer,
    UserRole.Controller,
    UserRole.Owner,
    UserRole.OrganizationOwner,
  ];
  public static TRUCK_UTILIZATION_REPORT = [
    UserRole.Customer,
    UserRole.Controller,
    UserRole.Owner,
    UserRole.OrganizationOwner,
  ];

  public static USERS_VIEW = [UserRole.Owner, UserRole.OrganizationOwner];
  public static PROFILE_VIEW = [UserRole.Customer, UserRole.Controller, UserRole.Owner, UserRole.OrganizationOwner];
  public static PROFILE_EDIT = [UserRole.Owner, UserRole.OrganizationOwner];

  public static CUSTOMERS_VIEW_LIVE_TRACKING = [UserRole.OrganizationOwner];

  public static SHIPMENT_DELIVERY_NOTE_ADD_EDIT = [
    UserRole.Fleet,
    UserRole.Customer,
    UserRole.Controller,
    UserRole.Owner,
  ];
  public static SHIPMENT_DELIVERY_NOTE_ID_ONLY_ADD_EDIT = [
    UserRole.Owner,
    UserRole.Customer,
    UserRole.Controller,
    UserRole.OrganizationOwner,
  ];
  public static TRANSPORTATION_PAYMENTS_VIEW = [UserRole.Fleet];
  public static SHIPMENT_FILTRATION_CUSTOMER_VIEW = [
    UserRole.Owner,
    UserRole.Customer,
    UserRole.Controller,
    UserRole.Fleet,
  ];
  public static SHIPMENT_FILTRATION_ORGANIZATION_VIEW = [UserRole.OrganizationOwner];
  public static SHIPMENT_FLEET_PRICE_VIEW = [UserRole.Fleet];
  public static SHIPMENT_PRICE_VIEW = [
    UserRole.Customer,
    UserRole.Controller,
    UserRole.OrganizationOwner,
    UserRole.Owner,
  ];
  public static SHIPMENT_CUSTOMER_PRICE_VIEW = [
    UserRole.Customer,
    UserRole.Controller,
    UserRole.OrganizationOwner,
    UserRole.Owner,
  ];

  public static RECEIVERS_VIEW = [UserRole.Customer, UserRole.Controller, UserRole.Owner];

  public static USER_PARAMS_VIEW = [UserRole.OrganizationOwner];
  public static USER_PARAMS_ADD = [UserRole.Owner, UserRole.OrganizationOwner];

  public static HEAT_MAP_VIEW = [UserRole.OrganizationOwner];
  public static ORDERS = [UserRole.Customer, UserRole.Controller, UserRole.Owner];

  // live tracking
  public static AVL_TRACKING_FILTERS = [UserRole.OrganizationOwner];
  public static WCC_LOGS_VIEW = [UserRole.Controller];
}
